'use strict';

function CompanyChecklistService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/checklist/:checklistID', {}, {
    'update': {
      method: 'PUT'
    },
    'delete': {
      method: 'DELETE'
    },
    'queryConnected': {
      url: config.apiBase + '/companies/:companyId/checklist/:checklistID/connecteds',
      method: 'GET',
      isArray: true
    }
  });
}

angular.module('dokiv')
  .factory('CompanyChecklistService', ['$resource', 'config', CompanyChecklistService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/checklist/CompanyChecklistService.js
// module id = 10
// module chunks = 0